"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.refreshBridgePool = exports.refreshReserves = void 0;
const models_1 = require("../../../models");
const bridgePool_1 = require("../../../utils/bridgePool");
const MAX_RESERVE_LENGTH = 3;
const refreshReserves = (connection, marketConfig, instructions, reserves, lendingProgramID) => __awaiter(void 0, void 0, void 0, function* () {
    if (reserves.length === 0) {
        return;
    }
    if (reserves.length > MAX_RESERVE_LENGTH) {
        const startReserves = reserves.slice(0, MAX_RESERVE_LENGTH);
        yield refreshBridgePool(connection, marketConfig, instructions, startReserves);
        instructions.push((0, models_1.refreshReservesInstruction)(startReserves, lendingProgramID));
        const endReserves = reserves.slice(MAX_RESERVE_LENGTH, reserves.length);
        yield (0, exports.refreshReserves)(connection, marketConfig, instructions, endReserves, lendingProgramID);
    }
    else {
        yield refreshBridgePool(connection, marketConfig, instructions, reserves);
        instructions.push((0, models_1.refreshReservesInstruction)(reserves, lendingProgramID));
    }
});
exports.refreshReserves = refreshReserves;
function refreshBridgePool(connection, marketConfig, instructions, reserves) {
    return __awaiter(this, void 0, void 0, function* () {
        for (const reserve of reserves) {
            if (reserve.info.isLP) {
                const bridgePoolProgram = yield (0, bridgePool_1.getBridgeProgram)(connection, marketConfig);
                const bridgePoolID = reserve.info.liquidity.params_1;
                const bridgePool = yield (0, bridgePool_1.getBridgePool)(bridgePoolID, connection, marketConfig);
                instructions.push(bridgePoolProgram.instruction.refresh({
                    accounts: {
                        pool: bridgePoolID,
                        lpPrice: bridgePool.lpPriceAccount,
                        ammId: bridgePool.ammId,
                        lpMint: bridgePool.lpMint,
                        lpSupply: bridgePool.lpSupply,
                        coinMintPrice: bridgePool.coinMintPrice,
                        pcMintPrice: bridgePool.pcMintPrice,
                        ammOpenOrders: bridgePool.ammOpenOrders,
                        coinMintSupply: bridgePool.ammCoinMintSupply,
                        pcMintSupply: bridgePool.ammPcMintSupply,
                        farmLedger: bridgePool.farmLedger,
                    }
                }));
            }
        }
    });
}
exports.refreshBridgePool = refreshBridgePool;
